exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".selected-item[data-v-a7750c0e] {\n  width: 100%;\n  padding: 5px 10px;\n}\n.dropdown[data-v-a7750c0e] {\n  width: 100%;\n  max-height: 300px;\n}\n.item-list[data-v-a7750c0e] {\n  padding: 0 30px 0 10px;\n}\n.item[data-v-a7750c0e] {\n  display: block;\n  padding: 10px 5px;\n  cursor: pointer;\n}\n.item[data-v-a7750c0e]:hover {\n  background-color: rgba(0,0,0,0.1);\n}\n", ""]);

// exports
